import styled from "styled-components";
import { Device } from "../../../../styles/screenSizes";
import { colors } from "../../../../styles/variables";

export const StyledUser = styled.div`
  @media ${Device.mobile} {
    display: none;
  }
`;

export const StyledHeaderSupport = styled.div`
  cursor: default !important;
  color: ${colors.black};
`;

export const StyledHeaderSupportLink = styled.div`
  font-size: 10px;
  color: ${({ theme }) => theme.color.primary};
`;

export const StyledHeaderDropdown = styled.a`
  color: ${({ theme }) => theme.color.primary};
`;

export const StyledDropdownMenu = styled.div<{ isOpen: boolean }>`
  display: none;

  ${({ isOpen, theme }) =>
    isOpen &&
    `
      display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10001;
    position: absolute;
    font-size: 0.9rem;
    color: ${theme.color.primary};
    background-color: ${colors.white};
    min-width: 100px;
    margin-top: 16px;
    padding: 5px;

    ::after {
      content: " ";
      position: absolute;
      bottom: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 9px;
      border-style: solid;
      border-color: transparent transparent ${colors.white} transparent;
    }

    & > * {
      width: 100%;
      text-align: center;
      cursor: pointer;
      padding: 5px 0;
    }
  `}
`;

export const StyledLabel = styled.span`
  margin-left: 5px;
  color: ${({ theme }) => theme.header?.shop?.navLinkColor || colors.white};
  font-size: 14px;
`;

export const StyledIconAndText = styled.span`
  display: flex;
  align-items: center;
  margin-left: 20px;
  cursor: pointer;
  /*
  svg {
    width: 18px;

    path {
      fill: ${({ theme }) => theme.header?.shop?.navLinkColor || colors.white};
    }
  } */
`;
